import { ApiRequestService } from './api-request';

export * from './api-schema-validations';

export const InternalApiRequest = new ApiRequestService({}, false);

// uncomment if needed
// export const noInterceptorsApiService = new ApiRequestService({}, true);
